export default "__VITE_PUBLIC_ASSET__a9ed0ecd__"